import { DropDownBox, ScrollView, SelectBox } from 'devextreme-react';
import DataGrid, { Column, FilterRow, Lookup, Scrolling, Selection } from 'devextreme-react/data-grid';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { useAuth } from '../../../auth';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { getAllWarehouses } from '../../../services/apis';
import useFormatMessage from '../../../utils/useFormatMessage';
const InventoryManagement = () => {
    const { hasRole } = useAuth(8);
    const { t } = useFormatMessage();
    const [formData, setFormData] = useState({ depoAdi: null, bolgeAdi: null, koordinat: null, yon: null, siralama: { start: null, end: null } });
    const [validationErrors, setValidationErrors] = useState({});
    const [isTableVisible, setIsTableVisible] = useState(false);
    const [dataGridData, setDataGridData] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const [zones, setZones] = useState([]);
    const [select, setSelect] = useState(null);
    const [selectModel, setSelectModel] = useState(null);
    const [status, setStatus] = useState(formData.status || false);
    const [brands, setBrands] = useState([]);
    const [models, setModels] = useState([]);

    const mountedRef = React.useRef(true);


    useEffect(() => {
        fetchWarehouses();
        fetchBrands();
        fetchModels();
        // eslint-disable-next-line
    }, []);

    const notify = (message, type) => toast[type](message);

    const fetchWarehouses = async () => {
        try {
            const response = await getAllWarehouses();
            setWarehouses(response);
        } catch {
            notify(t("Depo Listesi Alınırken hata oluştu"), "error");
        }
    };

    const fetchZones = async (warehouseId) => {
        try {
            const { data } = await api.post('/zone/getZonesByWarehouse', { warehouse_id: warehouseId });
            let all_data = data.data || [];

            setZones(
                all_data.filter((item) => (item.zone_name !== "SANAL" && item.is_active === true))
            );
        } catch {
            notify(t("Bölge Listesi Alınırken hata oluştu"), "error");
        }
    };

    const handleInputChange = (field, value, nestedField = null) => {
        setFormData(prev => nestedField
            ? { ...prev, [field]: { ...prev[field], [nestedField]: value } }
            : { ...prev, [field]: value });
        setValidationErrors(prev => ({ ...prev, [field]: false }));
    };

    const validateForm = () => {
        const errors = {};

        // Only check if warehouse (depoAdi) is selected
        if (!formData.depoAdi) {
            errors.depoAdi = true;
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleListClick = () => {

        if (validateForm()) fetchAddressData();
        else notify(t("Lütfen tüm alanları doldurunuz"), "error");
    };

    const fetchAddressData = async () => {
        const body = {
            coordinate: formData.koordinat === null ? null : formData.koordinat,
            direction: formData.yon === null ? null : formData.yon,
            end_seq: formData.siralama.end === null ? null : parseInt(formData.siralama.end),
            start_seq: formData.siralama.start === null ? null : parseInt(formData.siralama.start),
            warehouse_id: parseInt(formData.depoAdi),
            zone_id: parseInt(document.getElementById("bolgeAdi-s").childNodes[0].childNodes[0].value)
        };
        try {
            const { data } = await api.post('/adress/getByParams', body);
            if (data.data === null) {
                setIsTableVisible(false);
                notify(t("Adres Bulunamadı"), "error");
                return;
            }
            setDataGridData(data.data || []);
            setIsTableVisible(true);
        } catch {
            notify(t("Adres Listesi Alınırken hata oluştu"), "error");
        }
    };

    const replaceAddressInError = (error) => {
        // "cannot set address SA-3 to empty: address is in use" formatındaki hatayı yakala
        const match = error.match(/cannot set address (.*?) to empty: address is in use/);
        if (match) {
            return `${t("Adres")} ${match[1]} ${t("boş olarak ayarlanamaz: Adres kullanımda")}`;
        }
        return t(error);
    };

    const handleUpdate = async () => {
        const body = {
            warehouse_id: parseInt(document.getElementById("depoAdi").childNodes[0].childNodes[0].value),
            address_ids: dataGridData.map((item) => item.id),
            update_user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
        };
        if (document.getElementById("kapasite").value !== "") {
            body.capacity = parseInt(document.getElementById("kapasite").value);
        }
        if (document.getElementById("adres-durumu").childNodes[0].childNodes[0].value !== "") {
            body.is_active = document.getElementById("adres-durumu").childNodes[0].childNodes[0].value === "true";
        }
        if (document.getElementById("bolgeAdi").childNodes[0].childNodes[0].value !== "") {
            body.zone_id = parseInt(document.getElementById("bolgeAdi").childNodes[0].childNodes[0].value)
        }

        try {
            const { data } = await api.post('/adress/update', body);
            if (data.success === true) {
                notify(t("updateSuccess"), "success");
                setTimeout(() => {
                    fetchAddressData();

                }, 200);
            } else {
                notify(t("updateFailed"), "error");
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error || error.message;
            notify(replaceAddressInError(errorMessage), "error");
        }
    };

    const renderFormInput = (id, label, value, onChange, isInvalid = false, type = "text") => (
        <FormGroup>
            {label && <Label for={id} style={{ fontWeight: "bold" }}>{t(label)}</Label>}
            <Input id={id} type={type} defaultValue={value} onChange={onChange} className={isInvalid ? 'is-invalid' : ''} />
        </FormGroup>
    );

    const fetchBrands = async () => {
        try {
            const response = await api.post("/getAllBrands");
            if (mountedRef.current) { // Only update state if component is mounted
                setBrands(response.data.data || []);
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Markalar alınırken hata oluştu') + ":" + errorMessage);
            console.error("Error fetching brands:", error);
        }
    };

    const fetchModels = async () => {
        try {
            const response = await api.post("/getAllModels");
            if (mountedRef.current) { // Only update state if component is mounted
                setModels(response.data.data || []);
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Modeller alınırken hata oluştu') + ":" + errorMessage);
            console.error("Error fetching models:", error);
        }
    };
    const dropDownButtonRender = (data) => {
        return (
            <>
                <ScrollView
                    id="scrollview"
                    // scrollByContent={true}
                    // bounceEnabled={true}
                    showScrollbar="always"
                // scrollByThumb={true}
                >
                    <DataGrid dataSource={models} keyExpr="id"
                        height={280}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        onSelectionChanged={(e) => {
                            setSelectModel(e.selectedRowKeys);
                        }}
                    >
                        <FilterRow visible={true} />
                        <Selection mode="multiple" />
                        <Column dataField="model_name" caption="Model" allowGrouping={false}
                        />
                        <Column dataField="vehicle_type" caption="Araç Tipi" calculateDisplayValue={(e) => t(e.vehicle_type)} >
                            <Lookup dataSource={vehicleTypes}
                                valueExpr="value"
                                displayExpr="text"
                            />
                        </Column>
                        <Scrolling mode='infinite' showScrollbar='always' />

                    </DataGrid>
                </ScrollView>
            </>
        );
    }
    const vehicleTypes = [
        { value: "PASSENGER", text: t("PASSENGER") },
        { value: "COMMERCIAL", text: t("COMMERCIAL") },
        { value: "HEAVY_COMMERCIAL", text: t("HEAVY_COMMERCIAL") },
    ];


    return (
        <>
            <Breadcrumb current={t("Adres Değiştirme")} />
            <Card className="p-4">
                <Row className="mb-4 justify-content-between">
                    <Col md="6" className='adress-change-criteria'>
                        <span style={{ fontSize: "x-large" }}>{t("Kriterler")}:</span>
                        <hr />
                        <Form>
                            <FormGroup>
                                <Label for="depoAdi" style={{ fontWeight: "bold" }}>{t("Depo Adı")}</Label>
                                <SelectBox
                                    id="depoAdi"
                                    dataSource={warehouses}
                                    displayExpr="warehouse_name"
                                    valueExpr="id"
                                    isValid={(validationErrors.depoAdi === false || validationErrors.depoAdi === undefined)}
                                    value={formData.depoAdi}
                                    onValueChange={(value) => {
                                        handleInputChange('depoAdi', value);
                                        fetchZones(value);
                                    }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="bolgeAdi" style={{ fontWeight: "bold" }}>{t("Bölge Adı")}</Label>
                                <SelectBox
                                    id="bolgeAdi-s"
                                    dataSource={zones}
                                    isValid={(validationErrors.bolgeAdi === false || validationErrors.bolgeAdi === undefined)}
                                    displayExpr="zone_name"
                                    valueExpr="id"
                                    value={formData.bolgeAdi}
                                    onValueChange={(value) => handleInputChange('bolgeAdi', value)}
                                />
                            </FormGroup>
                            {renderFormInput("koordinant", "Koordinant", formData.koordinat, (e) => handleInputChange("koordinat", e.target.value), validationErrors.koordinat)}
                            {renderFormInput("yon", "Yön", formData.yon, (e) => handleInputChange("yon", e.target.value), validationErrors.yon)}
                            <FormGroup>
                                <Label style={{ fontWeight: "bold" }}>{t("Sıra")}</Label>
                                <Row>
                                    <Col md="6">
                                        {renderFormInput("sira-start", "", formData.siralama.start, (e) => handleInputChange("siralama", e.target.value, "start"), validationErrors.siralama?.start)}
                                    </Col>
                                    <Col md="6">
                                        {renderFormInput("sira-end", "", formData.siralama.end, (e) => handleInputChange("siralama", e.target.value, "end"), validationErrors.siralama?.end)}
                                    </Col>
                                </Row>
                            </FormGroup>
                            <div className="d-flex justify-content-end">
                                <Button color="warning" className="mt-2" onClick={handleListClick}>
                                    <i className="fa fa-list"></i>&nbsp;{t("Listele")}
                                </Button>
                            </div>
                        </Form>
                    </Col>
                    {
                        isTableVisible
                        && (
                            <Col md="6" className='adress-change-criteria'>
                                <span style={{ fontSize: "x-large" }}>{t("Yeni Değerler")}:</span>
                                <hr />
                                <Form>
                                    <FormGroup>
                                        <Label style={{ fontWeight: "bold" }}>{t("Adres Durumu")}</Label>
                                        {/* <Switch id="status"
                                            onValueChanged={(e) => {
                                                setStatus(e.value)
                                            }
                                            }
                                            switchedOnText='Aktif'
                                            defaultValue={true}
                                            switchedOffText='Pasif'
                                            width={"30%"}
                                            className={status ? 'switch-active' : 'switch-inactive'}

                                        /> */}
                                        <SelectBox
                                            showClearButton={true}
                                            id="adres-durumu" dataSource={[{ id: true, status: t("Aktif") }, { id: false, status: t("Pasif") }]} displayExpr="status" valueExpr="id" />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="marka" style={{ fontWeight: "bold" }}>{t("Marka Tanımlama")}</Label>
                                        <SelectBox
                                            disabled={true}
                                            id="marka" dataSource={brands} displayExpr="brand_name" valueExpr="id" defaultValue={formData.marka}
                                            showClearButton={true}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label for="model" style={{ fontWeight: "bold" }}>{t("Modele Rezerve")}</Label>
                                        <DropDownBox
                                            disabled={true}
                                            dataSource={models}
                                            id="model"
                                            defaultValue={formData.model}
                                            value={selectModel}
                                            deferRendering={true}
                                            contentRender={dropDownButtonRender}
                                            displayExpr="model_name"
                                            valueExpr={"id"}
                                            onValueChanged={(e) => {
                                                handleInputChange('model', e.value);
                                            }}


                                        />

                                    </FormGroup>

                                    {renderFormInput("kapasite", "Kapasite", "", null, false, "number")}
                                    {/* bölge seçimi */}
                                    <FormGroup>
                                        <Label for="bolgeAdi" style={{ fontWeight: "bold" }}>{t("Bölge Adı")}</Label>
                                        <SelectBox
                                            id="bolgeAdi"
                                            showClearButton={true}
                                            dataSource={zones}
                                            displayExpr="zone_name"
                                            valueExpr="id"
                                        //defaultValue={formData.bolgeAdi}
                                        // onValueChange={(value) => handleInputChange('bolgeAdi', value)}
                                        />
                                    </FormGroup>
                                </Form>
                                <div className="d-flex justify-content-end">
                                    {
                                        hasRole("adres_guncelle_update") &&
                                        <Button color="success" className="mt-2" onClick={handleUpdate}>
                                            <i className="fa fa-save"></i>&nbsp;{t("Güncelle")}
                                        </Button>}
                                </div>
                            </Col>
                        )}
                </Row>
                {isTableVisible && (
                    <DatagridCustom
                        // keyExpr="id"
                        dataSource={dataGridData}
                        showBorders
                        rowAlternationEnabled
                        onSelectedRowKeysChange={(e) => {
                            setSelect(e);
                        }}
                    >
                        {/* <Selection mode="single" /> */}
                        <Column dataField="address_code" caption="Adres" alignment='center' />
                        <Column dataField="zone_name" caption="Bölge" alignment='center' />
                        <Column dataField="capacity" caption="Kapasite" alignment='center' />,
                        <Column dataField="used_capacity" caption="Kullanılan Adet" alignment='center' />
                        <Column dataField="status" caption="Durum" alignment='center' calculateDisplayValue={(data) => t(data.status)}
                        />
                        {/* <Paging defaultPageSize={5} />
                        <Pager showPageSizeSelector allowedPageSizes={[5, 10, 20]} showInfo /> */}
                        <Scrolling mode='infinite' showScrollbar='always' />
                    </DatagridCustom>
                )}
            </Card>
        </>
    );
};

export default InventoryManagement;
